import * as Types from '../../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RestoreMemberMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type RestoreMemberMutation = { __typename?: 'Mutation', restoreOrganisationMember: { __typename?: 'OrganisationMemberUser', id: string, archivedAt?: number | null } };


export const RestoreMemberDocument = gql`
    mutation RestoreMember($id: ID!) {
  restoreOrganisationMember(id: $id) {
    id
    archivedAt
  }
}
    `;
export type RestoreMemberMutationFn = Apollo.MutationFunction<RestoreMemberMutation, RestoreMemberMutationVariables>;

/**
 * __useRestoreMemberMutation__
 *
 * To run a mutation, you first call `useRestoreMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreMemberMutation, { data, loading, error }] = useRestoreMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreMemberMutation(baseOptions?: Apollo.MutationHookOptions<RestoreMemberMutation, RestoreMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreMemberMutation, RestoreMemberMutationVariables>(RestoreMemberDocument, options);
      }
export type RestoreMemberMutationHookResult = ReturnType<typeof useRestoreMemberMutation>;
export type RestoreMemberMutationResult = Apollo.MutationResult<RestoreMemberMutation>;
export type RestoreMemberMutationOptions = Apollo.BaseMutationOptions<RestoreMemberMutation, RestoreMemberMutationVariables>;